import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import "./Modal.css";
import { useState } from "react";
import Button from "@mui/material/Button";
import Textfield from "../atoms/Textfield";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import DropdownModal from "../atoms/DropdownModal";
import axios from "axios";
const styles = {
  floatingLabelFocusStyle: {
    color: "white",
  },
};

const Modal = (props) => {
  const [userInputs, setUserInputs] = useState({
    videoLink: "",
    thumbnail: "",
    title: "",
    genre: "",
    ageGroup: "",
    releaseDate: null,
  });
  const handleUpload = async () => {
    const data = userInputs;
    await postVideo(userInputs);
    props.isActive();
  };
  const inputFromUser = (key, value) => {
    setUserInputs({
      ...userInputs,
      [key]: value,
    });
  };

  const postVideo = async (data) => {
    try {
      const response = await axios.post(
        "https://00b1c9c8-063c-4f3e-ae43-b14f8ab76d4a.mock.pstmn.io/v1/videos",
        data
      );
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <div className="backdrop" />
      <div className="modal">
        <header className="header">
          <h2>Upload Video</h2>
          <CloseIcon onClick={props.isActive} />
        </header>

        <Textfield
          id="upload-btn-video"
          identifier="videoLink"
          inputFromUser={inputFromUser}
          value={userInputs.videoLink}
          label={"Video Link"}
          description=" This link will be used to derive the video"
        />
        <Textfield
          id="upload-btn-image"
          identifier={"thumbnail"}
          inputFromUser={inputFromUser}
          value={userInputs.thumbnail}
          label={"Thumbnail Image Link"}
          description="This link will be used to preview the thumbnail image"
        />
        <Textfield
          id="upload-btn-title"
          identifier={"title"}
          inputFromUser={inputFromUser}
          value={userInputs.title}
          label={"Title"}
          description="This link will be the presentation text for video"
        />

        <DropdownModal
          id="upload-btn-genre"
          identifier={"genre"}
          inputFromUser={inputFromUser}
          value={userInputs.genre}
          label="Genre"
          items={["Education", "Sports", "Comedy", "Lifestyle"]}
          description="Genre will help in categorizing your video"
        />

        <DropdownModal
          id="upload-btn-content-rating"
          identifier={"ageGroup"}
          inputFromUser={inputFromUser}
          value={userInputs.ageGroup}
          label="Suitable age group for the clip"
          items={["7+", "12+", "16+", "18+"]}
          description="This will be used to filter videos on age group suitability"
        />
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DesktopDatePicker
            label="Release Date"
            className="inputDiv "
            inputFormat="MM/dd/yyyy"
            sx={{
              display: "flex",
              justifyContent: "center",
              textAlign: "center",
              margin: "0px 13px",
              border: "none",
            }}
            value={userInputs.releaseDate}
            onChange={(date) => {
              setUserInputs({
                ...userInputs,
                releaseDate: date,
              });
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                id="upload-btn-release-date"
                className="inputDiv  floatingLabelFocusStyle"
                // value={userInputs.releaseDate}
                InputLabelProps={{
                  className: "floatingLabelFocusStyle",
                }}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  textAlign: "center",
                  margin: "0px 13px",
                }}
              />
            )}
          />
        </LocalizationProvider>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-start",
            marginTop: "10px",
          }}
        >
          <div style={{ marginLeft: "13px", marginBottom: "10px" }}>
            <Button
              id="upload-btn-submit"
              className="uploadBtn"
              variant="contained"
              onClick={handleUpload}
            >
              Upload Video
            </Button>
          </div>
          <div style={{ marginLeft: "13px" }}>
            <Button
              id="upload-btn-cancel"
              className="cancelBtn"
              variant="contained"
              onClick={props.isActive}
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Modal;
